import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { uploadMagazine } from '../../../../service/DashboardService';
import AWS from 'aws-sdk';
import { years } from '../../../../functions/YearGenerate';

const AddMagazine = (setShowAddMagazine) => {
    const [file, setFile] = useState(null);
    const [fileUrl, setFileUrl] = useState(null);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");
    const months = [
        { label: "January", value: "january" },
        { label: "February", value: "february" },
        { label: "March", value: "march" },
        { label: "April", value: "april" },
        { label: "May", value: "may" },
        { label: "June", value: "june" },
        { label: "July", value: "july" },
        { label: "August", value: "august" },
        { label: "September", value: "september" },
        { label: "October", value: "october" },
        { label: "November", value: "november" },
        { label: "December", value: "december" },
    ];

    useEffect(()=>{
        console.log(selectedMonth,selectedYear,'test');
    },[selectedMonth,selectedYear])


    const S3_BUCKET_NAME = 'balarch-dev';

    const uploadAdapter = async (file) => {
        const s3 = new AWS.S3({
            accessKeyId: "AKIA5XIUXJ77ZFNBD46L",
            secretAccessKey: "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",
            region: "ap-south-1",
        });

        const params = {
            Bucket: S3_BUCKET_NAME,
            Key: file.name,
            Body: file,
            ContentType: 'application/pdf',
        };

        try {
            const data = await s3.upload(params).promise();
            return data.Location;
        } catch (error) {
            throw new Error('Failed to upload file to S3: ' + error.message);
        }
    };



    const handlePdfUpload = async (event) => {
        const uploadedFile = event.currentTarget.files[0];
        setFile(uploadedFile);
        const s3Url = await uploadAdapter(uploadedFile);
        setFileUrl(s3Url);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!fileUrl) {
            console.error('No file uploaded');
            return;
        }

        try {
            const token = localStorage.getItem("accessToken");
            const magazineData = {
                MagazineFile: fileUrl,
                FileSize: `${(file.size / (1024 * 1024)).toFixed(2)}MB`,
                Month: selectedMonth,
                Year: selectedYear,
            };

            const response = await uploadMagazine(magazineData, token);

            if (response) {
                toast.success("Magazine added successfully");
            }
        } catch (error) {
            console.error("Submission error:", error);
            toast.error(error.message || "Something went wrong");
        }
    };


    const handleCancel = async (event) => {
        setShowAddMagazine(false);
    };

    return (
        <>
            <div>
                <div className='flex'>
                    <div className="h-full flex flex-row gap-5 px-4 py-4">
                        <div>
                            <select
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                                className="w-full border-2 border-gray-400 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                            >
                                <option className="font-normal" value="">
                                    Select Year
                                </option>
                                {years.map((mon, i) => (
                                    <option key={i} value={mon.value}>
                                        {mon.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <select
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                                className="w-full border-2 border-gray-400 rounded-md py-2 px-3 shadow-sm focus:outline-none focus:border-blue-500"
                            >
                                <option className="font-normal" value="">
                                    Select month
                                </option>
                                {months.map((mon, i) => (
                                    <option key={i} value={mon.value}>
                                        {mon.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                <div className="sm:col-span-2">
                    <label
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                        htmlFor="pdf_file"
                    >
                        Magazine <span className="text-red-500">*</span>
                    </label>
                    <input
                        className="block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        id="pdf_file"
                        type="file"
                        accept="application/pdf"
                        onChange={handlePdfUpload}
                    />
                    <p
                        className="mt-1 text-xs text-gray-800 dark:text-gray-300 float-right"
                        id="pdf_file_input_help"
                    >
                        {" "}
                        PDF (MAX. 5MB).
                    </p>
                </div>
                <div className='flex items-center gap-4 mt-10'>
                    <button
                        type="button"
                        class="focus:outline-none text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900"
                        onClick={handleCancel}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                        onClick={handleSubmit}
                    >
                        Submit
                    </button>
                </div>
            </div>

        </>
    )
}

export default AddMagazine;
